var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.svgContent)?_c('span',{directives:[{name:"html-safe",rawName:"v-html-safe",value:(_setup.svgContent),expression:"svgContent"}],staticClass:"fp-icon"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }